import React from "react";
import img1 from "../assets/images/mobile-1.png";
import img2 from "../assets/images/mobile-2.png";
import img3 from "../assets/images/mobile-3.png";

const News = () => {
  const data = [
    {
      img: img1,
      type: "UI/UX Development",
      desc: " Pixel Perfect UI",
    },
    {
      img: img2,
      type: "Native Functionalities",
      desc: " Overlay when you unlock your device",
    },
    {
      img: img3,
      type: "Library Integration",
      desc: " Progressive Graphical Report",
    },
  ];

  return (
    <div className="rn-blog-area pt--120 bg_color--1 mb-dec--30 pb--110">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="section-title text-left">
              <h2>Mobility Applications</h2>
              <p>
                Introducing VOCApp. <br/>A simple conceptual app loaded with tons of features to help improve your vocabulary.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="blog-btn text-left text-lg-right mt_sm--10 mt_md--10">
              <a className="btn-transparent rn-btn-dark" href="https://github.com/ricku44/VOCApp#readme" target='_blank' rel='noopener noreferrer'>
                <span id="Pages0" className="text">View Source Code</span>
              </a>
            </div>
          </div>
        </div>
        <div className="row mt--60 mt_sm--40">
          {data.map((item, i) => {
            return (
              <div className="col-lg-4 col-md-6 col-12 show-on-scroll" key={item.type + i}>
                <div className="blog blog-style--1">
                  <div className="thumbnail">
                    <a
                      href="https://github.com/ricku44/VOCApp#readme"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img className="w-100" src={item.img} alt="Blog Images" />
                    </a>
                  </div>
                  <div className="content">
                    <p className="blogtype">{item.type}</p>
                    <h4 className="title">
                      <a
                        href="https://github.com/ricku44/VOCApp#readme"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.desc}
                      </a>
                    </h4>
                    <div className="blog-btn">
                      <a
                        className="rn-btn text-white"
                        href="https://github.com/ricku44/VOCApp#readme"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default News;
